import { useEffect, useRef, useState } from 'react'

export const useAnimation = () => {
	const [dashOffset, setDashOffset] = useState<number>(0)
	const [pointsAmount, setPointsAmount] = useState<number>(0)
	const animationFrameId = useRef<number | null>(null)
	const lastTime = useRef<number>(0)

	const animate = (time: number) => {
		if (!lastTime.current) lastTime.current = time

		// Ограничиваем частоту обновления (например, каждые 30 мс)
		if (time - lastTime.current >= 30) {
			setDashOffset(prevOffset => prevOffset + 3)
			setPointsAmount(prev => (prev + 1) % 40)
			lastTime.current = time
		}

		animationFrameId.current = requestAnimationFrame(animate)
	}

	useEffect(() => {
		// Запускаем анимацию
		animationFrameId.current = requestAnimationFrame(animate)

		// Очистка при размонтировании
		return () => {
			if (animationFrameId.current) {
				cancelAnimationFrame(animationFrameId.current)
			}
		}
	}, [])

	const backgroundImage: string = `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='30' ry='30' stroke='%23808AFF' stroke-width='4' stroke-dasharray='12 15' stroke-dashoffset='${dashOffset}' stroke-linecap='square'/%3e%3c/svg%3e")`

	return {
		backgroundImage,
		pointsAmount,
	}
}
